import type { FaireProductEntity } from "../../entity_types/product";

export const p_99chn9r24n: FaireProductEntity = {
  token: "p_99chn9r24n",
  type: "product",
  name: "Petal Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/c2e1c0d4387de0a3d351d3b9f22711bc1c4e07e2d540e8c9c6cf424e0a1d2729.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b48d0bd6b037da0132d49a564cf9af1b98ee8e562140af9855f05421410f380c.jpeg",
    "https://cdn.faire.com/fastly/16f5b60666a6ee369dd178aa13152ba107817db15d36e8effbcf8588e6c48c06.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:17.793Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
